/* External dependencies */
import React from 'react';
import { Provider } from 'react-redux';

/* Local dependencies */
import { store } from './store';

export default ({ element }) => {
  return <Provider store={store}>{element}</Provider>;
};
